
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

var $d9d0032a5a695c41$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"fQ1rW\",\"PageLabelsAutomationDiscovery.eff4fc98.js\",\"1UoOL\",\"tooltip.578c49ed.js\",\"faXeM\",\"main.49e6530c.js\",\"hDCAz\",\"panel.ab2ff1e4.js\",\"7eOUa\",\"main.b89968f4.js\",\"9zjWJ\",\"main.f21ecdb8.js\",\"cwwPf\",\"main.38d08a49.js\",\"3a4K1\",\"main.7f9142b1.js\",\"9J4KV\",\"cs.54ef28aa.js\",\"8Y9JE\",\"da.798af7ab.js\",\"gWrRN\",\"de.599dfe79.js\",\"irKcy\",\"en.cb5065bc.js\",\"1aghR\",\"en_GB.5c376bf0.js\",\"3jFnE\",\"en_ZZ.d99a7b0a.js\",\"11Khz\",\"es.4234b43e.js\",\"ap0LY\",\"et.696bc5a5.js\",\"34Ma8\",\"fi.fa973dd3.js\",\"lBwDa\",\"fr.7e788bda.js\",\"32Pvr\",\"hu.7e92d300.js\",\"b7bFd\",\"is.e7ff8171.js\",\"6h8Ae\",\"it.517334ca.js\",\"dW8Ws\",\"ja.4f520a80.js\",\"fJZdm\",\"ko.9807b518.js\",\"kfTIE\",\"nb.9aa8d88f.js\",\"b8M9e\",\"nl.7da0b271.js\",\"jMchi\",\"pl.4f9f4d02.js\",\"2xsmF\",\"pt_BR.d6ec8c41.js\",\"hHyCx\",\"pt_PT.0fefd654.js\",\"gw4Pw\",\"ro.b9dc4307.js\",\"8rhcn\",\"ru.cb3b0257.js\",\"fh5Vk\",\"sk.7fe3861a.js\",\"aP4eD\",\"sv.702b5424.js\",\"aJWAE\",\"th.4aed32d3.js\",\"b96A2\",\"tr.e20d9285.js\",\"g0ukK\",\"uk.900ccbcc.js\",\"8DuKk\",\"vi.5d57241c.js\",\"5aSRq\",\"zh_TW.5dd8b6cc.js\",\"eQT38\",\"zh.4739bce0.js\"]"));


//# sourceMappingURL=PageLabelsAutomationDiscovery.runtime.aedfdf55.js.map
